import { RigTypeBase } from './base/rig-type-base';

export class RigType extends RigTypeBase { }